import React, { Component, createRef } from 'react';
import {
  BuscadorTop, ContainerBuscador, FiltroBtn, FiltroBadge,
  FiltroSep, SearchBox, SearchButton, VistaBtn,  TooltipWrap
} from './Buscador.styles';

class Buscador extends Component {
  inputRef = createRef();

  onSubmit = (e) => {
    e.preventDefault();
    this.props.onBuscar(this.inputRef.current.value.trim());
  };

  render() {
    const { onAbrirFiltro, totalFiltros, vistaPlana, onToggleVista } = this.props;
    return (
      <BuscadorTop onSubmit={this.onSubmit}>
        <ContainerBuscador>
          <FiltroBtn type='button' onClick={() => onAbrirFiltro(this.inputRef.current.value.trim())}>
            <svg width='14' height='14' viewBox='0 0 24 24' fill='currentColor'>
              <path d='M3 5h18v2l-7 7v5l-4-2v-3L3 7V5z'/>
            </svg>
            Filtro
            {totalFiltros > 0 && (
              <FiltroBadge>{totalFiltros}</FiltroBadge>
            )}
          </FiltroBtn>
          {onToggleVista && (
            <>
              <FiltroSep />
              <VistaBtn
                type='button'
                active={vistaPlana}
                onClick={onToggleVista}
          
              >
                  <TooltipWrap data-tooltip={vistaPlana ? 'Ver agrupado por trastero' : 'Ver todos los artículos en una sola lista'}>
                {vistaPlana ? '⊞' : '▦'}
                </TooltipWrap>
              </VistaBtn>
            </>
          )}
          <FiltroSep />
          <SearchBox
            ref={this.inputRef}
            type='text'
            placeholder='Buscar...'
            autoFocus
          />
          <SearchButton>Go</SearchButton>
        </ContainerBuscador>
      </BuscadorTop>
    );
  }
}

export default Buscador;
